import i18n from "../i18/i18n";

export const te = (errorCode) => {
  let error = errorCode;
  if (!errorCode || errorCode.length === 0) error = "general_error";
  return i18n.t(`errors.${error}`);
};
